import { Box, IconButton, Tooltip } from "@mui/material";
import { useCheckRoleAccess } from "shared/hooks/useCheckRoleAccess";
import style from "../styles/detailedConsultation.module.scss";
import { TotalValueField } from "./conctact-details/TotalValueField";
import { accesRoles, GET_ELECTRONIC_DOCS, roles as userRol } from "shared";
import { putData } from "shared/api/services/putData";
import { useNavigate } from "react-router-dom";
import { useContractContext } from "../contexts/ContractContext";

interface IViewDetailButtonProp {
  index: number;
  value: any;
  onClickIcon: () => void;
  typeIcon: string;
  column?: any;
  roles?: string[];
  titleTooltip?: string;
  onlyIcon?: boolean;
  disabledButton?: boolean;
  idDocument?: string | undefined;
  onContractUpdate?: (contractNumber: string) => void;
}

export const ViewDetailButton = ({
  index,
  value,
  column,
  roles,
  titleTooltip,
  onlyIcon,
  disabledButton = true,
  onClickIcon,
  typeIcon,
  idDocument,
  onContractUpdate,
}: IViewDetailButtonProp) => {
  const { checkRoles } = useCheckRoleAccess();
  const navigate = useNavigate();
  const { triggerContractUpdate } = useContractContext();

  const confirmUpdateContract = async (currentValue: string): Promise<any> => {
    const result = await putData(
      `${GET_ELECTRONIC_DOCS}/${idDocument}/contract-number`,
      { contractNumber: currentValue },
    );

    // Notificar a otros componentes que el contrato se actualizó
    triggerContractUpdate();

    return result;
  };

  return (
    <Box
      className={style.inputViewDetailsContainer}
      data-testid="content_view_detail"
    >
      {checkRoles(accesRoles.auditor) ? (
        <TotalValueField
          value={value?.content[column.idLabel] || value}
          index={index}
          confirmUpdate={confirmUpdateContract}
          label="Número"
          userRol={accesRoles.auditor}
        />
      ) : (
        <input
          data-testid={`input_value_${index}`}
          className={style.inputDetails}
          type="text"
          disabled
          value={value?.content[column.idLabel] || value}
        />
      )}
      {roles &&
      checkRoles(roles) &&
      value?.content[column.idLabel] !== "Información no disponible" ? (
        <Tooltip
          title={titleTooltip ?? ""}
          placement="top"
          arrow
          data-testid={`tooltip_${index}`}
        >
          <IconButton
            className={style.viewButton}
            onClick={onClickIcon}
            disableRipple
            disabled={disabledButton}
            data-testid="icon_view_detail"
          >
            <img src={typeIcon} alt="Ver detalle" />
          </IconButton>
        </Tooltip>
      ) : (
        onlyIcon && (
          <IconButton
            className={style.viewButton}
            onClick={onClickIcon}
            disableRipple
            disabled={disabledButton}
            data-testid="icon_view_detail2"
          >
            <img src={typeIcon} alt="Ver detalle" />
          </IconButton>
        )
      )}
    </Box>
  );
};
